import React from "react";
import styles from "./Detail.module.css";

function Detail(props) {
    return (
        <div className={styles.display}>
            <div className={styles.text}>
                {props.text}
            </div>
            <div className={styles.subtext}>
                {props.subtext}
            </div>
        </div>
    );
}

export default Detail;